function loader() {
    return (
        <div className="fixed inset-0 flex flex-col justify-center items-center min-h-screen">
            <div className="fixed inset-0 bg-[#202020] opacity-75" />
            <div className="w-8 h-8 border-[1rem] border-[#E0E0E0] border-t-[#FF671F] rounded-full animate-spin" />
        </div>
    );
}

export default loader;
